module.exports = "/assets/1db040886bccb97b26a2c163429e2566.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/QC.png
// module id = 1746
// module chunks = 0